import React, { useState, useEffect } from "react";
import Select, { components } from "react-select";
import styled, { css } from "styled-components";

const commonStyles = css`
  font-family: Arial, sans-serif;
  font-size: 1.4rem;
  font-weight: 400;
`;

const fixedWidth = '100px'; // Set the fixed width you desire

const customStyles = (zoomLevel) => ({
  control: (provided, state) => ({
    ...provided,
    fontSize: "1.4rem",
    border: "1px solid #9a9a9a",
    borderRadius: "0px",
    minHeight: "2em",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      border: "1px solid #0078c9",
    },
    width: fixedWidth, // Set a fixed width for the control
    height: "35px",
    position: "relative",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    width: "20px",
    height: "10px",
    marginLeft: "8px",
    marginRight: "8px",
    transform: state.menuIsOpen ? "rotate(180deg)" : null,
    position: "relative",
    top: '6px',
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    padding: 0,
    height: "20px",
    justifyContent: "flex-end",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    paddingLeft: "5px",
    width: `calc(${fixedWidth} - 30px)`, // Adjust width to fit inside the control
  }),
  input: (provided, state) => ({
    ...provided,
    margin: 0,
    padding: 0,
  }),
  menu: (provided, state) => ({
    ...provided,
    marginTop: 0,
    borderRadius: "0px",
    border: "1px solid #0078c9",
    paddingTop: "0.5em",
    paddingBottom: "0.5em",
    width: fixedWidth, // Set the same fixed width for the dropdown menu
    backgroundColor: "white",
    zIndex: 1000,
  }),
  menuList: (provided, state) => ({
    ...provided,
    padding: 0,
    borderRadius: 0,
    backgroundColor: "white",
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: "1.4rem",
    backgroundColor: state.isSelected ? "white" : "white",
    color: state.isSelected ? "black" : "#333",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  }),
  singleValue: (provided, state) => ({
    ...provided,
    position: "relative",
    top: `${zoomLevel * 0}px`,
  }),
});

const Label = styled.label`
  ${commonStyles}
  display: block;
  margin-bottom: 0.5em;
`;

const CustomOption = (props) => (
  <components.Option {...props}>
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      <span style={{ flex: 1 }}>{props.data.label}</span>
      {props.isSelected && (
        <img
          src={require("../images/tick.png")}
          alt="Different Image"
          style={{ width: "16px", height: "16px", marginLeft: "auto" }}
        />
      )}
    </div>
  </components.Option>
);

const CustomDropdownIndicator = ({ selectProps, ...props }) => (
  <components.DropdownIndicator {...props}>
    <img
      src={require("../images/arrow.png")}
      alt="Dropdown Arrow"
      style={{
        width: "16px",
        // height: '1vh',
        marginLeft: "5px",
        marginRight: "1px",
        transform: selectProps.menuIsOpen ? "rotate(180deg)" : null,
        position: "relative",
        top: `${selectProps.zoomLevel * 0}px`,
      }}
    />
  </components.DropdownIndicator>
);

const SelectBoxWithLabel = ({ label, options, onChange, value }) => {
  const [zoomLevel, setZoomLevel] = useState(0);
  const [controlWidth, setControlWidth] = useState('100px'); // Default width

  useEffect(() => {
    const handleZoom = () => {
      setZoomLevel(window.devicePixelRatio - 1);
    };

    const handleResize = () => {
      const width = document.querySelector('.custom-select-container')?.offsetWidth || '100px';
      setControlWidth(width);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initialize the control width
    handleZoom(); // Initialize the zoom level

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="custom-select-container">
      <Label>{label}</Label>
      <Select
        options={options}
        styles={customStyles(zoomLevel)}
        onChange={onChange}
        value={options.find((option) => option.value === value)}
        components={{
          Option: (props) => (
            <CustomOption
              {...props}
              selectProps={{ ...props.selectProps, zoomLevel }}
            />
          ),
          DropdownIndicator: (props) => (
            <CustomDropdownIndicator
              {...props}
              selectProps={{ ...props.selectProps, zoomLevel }}
            />
          ),
        }}
      />
    </div>
  );
};

export default SelectBoxWithLabel;
